import { roleOption, UserKeys } from "@sso/constant";
import { SearchFieldKeys, SearchParameterKeys, TableColumn } from "@sso/types";

export const userTableColumns: TableColumn<UserKeys>[] = [
  {
    name: "Name",
    field: UserKeys.FULL_NAME,
    sortable: true,
    search: { type: SearchFieldKeys.TEXT },
  },
  {
    name: "Email",
    field: UserKeys.EMAIL,
    sortable: true,
    search: { type: SearchFieldKeys.TEXT },
  },
  {
    name: "Organisation",
    field: UserKeys.ORGANISATION_NAME,
    search: { type: SearchFieldKeys.TEXT },
    sortable: true,
  },
  {
    name: "Role",
    field: UserKeys.ROLE_NAME,
    search: {
      type: SearchFieldKeys.SELECT,
      options: roleOption,
      searchParamaterKey: SearchParameterKeys.CONTAIN,
      field: "Roles.Name",
    },
    sortable: true,
  },
  {
    name: "Products",
    field: UserKeys.SOFTWARES_NAME,
  },
  {
    name: "Created",
    field: UserKeys.CREATED,
    sortable: true,
  },
  {
    name: "Last login",
    field: UserKeys.LAST_LOGIN,
    sortable: true,
  },
];
